<ng-template *ngIf="templateRef; then refTpl else messageTpl"> </ng-template>

<ng-template #refTpl [ngTemplateOutlet]="templateRef"></ng-template>
<ng-template #messageTpl>
  <span [innerHTML]="message"></span>
</ng-template>
